import { useEffect, useState } from 'react';
import { request } from '../../api/client';
import { ApiError } from '../../api';
import { downloadFile } from '../../api/reports';

interface Info {
  version: string;
  file: string;
  sha256: string;
  size: number;
}

// «Kassa proqramını yüklə» (KT-80): saytdan, yalnız sahib və menecer; versiya və SHA-256 göstərilir, yükləmə auditdədir.
export function DesktopDownload() {
  const [info, setInfo] = useState<Info | null>(null);
  const [missing, setMissing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    request<Info>('GET', '/api/downloads/desktop')
      .then(setInfo)
      .catch((err: unknown) => (err instanceof ApiError && err.status === 404 ? setMissing(true) : setError('Məlumat yüklənmədi')));
  }, []);

  if (missing) return <p className="muted small">Kassa masaüstü proqramı hələ serverə qoyulmayıb.</p>;
  if (error) return <p className="bad small">{error}</p>;
  if (!info) return null;
  return (
    <div className="device-connect" aria-label="Kassa proqramını yüklə">
      <button
        type="button"
        className="btn-primary"
        onClick={() => downloadFile('/api/downloads/desktop/file', info.file).catch(() => setError('Fayl yüklənmədi. Yenidən cəhd edin.'))}
      >
        Kassa proqramını yüklə
      </button>
      <p className="muted small">
        Versiya {info.version} · {(info.size / 1048576).toFixed(1).replace('.', ',')} MB · Windows 10/11 (64-bit). Quraşdırıcı imzasızdır — Windows
        «Naməlum naşir» deyə xəbərdarlıq edə bilər: «Ətraflı» → «Hər halda işlət».
      </p>
      <p className="muted small mono" style={{ overflowWrap: 'anywhere' }}>
        SHA-256: {info.sha256}
      </p>
    </div>
  );
}
